"use strict";
exports.__esModule = true;
exports.SLC_HOW_TO_PAY_FLEX_BACK_CONTENT = void 0;
exports.SLC_HOW_TO_PAY_FLEX_BACK_CONTENT = {
    HEADER: 'Choose how you pay Flex back',
    FIRST_PAYMENT: {
        TITLE: '1st payment',
        PRICING_LINE_ITEM: 'Includes {{processingPercentage}}% monthly interest ({{processingFeeAmount}}) \nUsing your personal debit card',
        BILL_PAYMENT_LINE_ITEM: 'Includes {{processingPercentage}}% bill payment fee ({{processingFeeAmount}}) \nUsing your personal debit card'
    },
    SECOND_PAYMENT: {
        TITLE: '2nd payment'
    },
    DEPOSIT: {
        TITLE: 'Pay with your deposit',
        CONTENT: 'Use your initial deposit to complete your repayment'
    },
    CARD: {
        TITLE: 'Pay with your debit card',
        CONTENT: 'We’ll charge your card for this payment and hold your deposit. You’ll be ready to pay rent with Flex the following month.'
    },
    CTA: 'Continue'
};
